import React, { Fragment, Component } from "react";

class AboutNewBG extends Component {
  render() {
    return (
      <Fragment>
        <div id="aaronaboutbg" className="z-10 absolute bottom-0">
          <img
            src="./about-main-min.png"
            className="md:h-[600px]"
            alt="Aaron Villanueva - About"
          />
        </div>
      </Fragment>
    );
  }
}

export default AboutNewBG;
